export default {
  LOGISTIC_MANAGER:{
    BASIC:{
      id: 1,
      value:"logistic_manager__1"
    },
    ADVANCED:{
      id: 2,
      value:"logistic_manager__2"
    },
    PRO:{
      id: 3,
      value:"logistic_manager__3"
    },
    PREMIUM:{
      id: 4,
      value:"logistic_manager__4"
    }
  },
  arr: [
    {
      id: 1,
      name:"logistic_manager__1",
      label: "Plano GO",
    },
    {
      id: 2,
      name:"logistic_manager__2",
      label: "Plano PLUS",
    },
    {
      id: 3,
      name:"logistic_manager__3",
      label: "Plano MASTER",
    },
    {
      id: 4,
      name:"logistic_manager__4",
      label: "Plano PRO",
    },
  ],
}
